import React from 'react';
import PropTypes from 'prop-types';
import DropdownItem from 'react-bootstrap/DropdownItem';
import withSounds from 'containers/withSounds';
import './MenuItemLink.css';

function MenuItemLink({
  title,
  url,
  target = '_self',
  onClick,
  ...otherProps
}) {
  const targetProps =
    target === '_self'
      ? {}
      : {
          rel: 'noopener noreferrer',
          target: target
        };

  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <div className="menu-item-link" {...otherProps}>
      <DropdownItem href={url} {...targetProps} onClick={handleClick}>
        {title}
      </DropdownItem>
    </div>
  );
}

MenuItemLink.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string
};

export default withSounds({ mouseEnterSound: true })(MenuItemLink);
